import { Icon, IconProps } from '@chakra-ui/react'

export default function InterferingBehaviorIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M.667 5.75a5.084 5.084 0 005.084 5.085c.603 0 1.18-.11 1.717-.303M5.75.667A5.085 5.085 0 00.668 5.75M10.532 7.468a5.056 5.056 0 00.303-1.716A5.084 5.084 0 005.751.667M10.642 10.87v.46M13.857 10.87v.46M13.354 13.82a2.45 2.45 0 01-2.255-.02M4.143 4.373v.46M7.358 4.373v.46M4.602 7.567a2.45 2.45 0 012.255.02"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M7.164 12.25a5.084 5.084 0 1010.17 0 5.084 5.084 0 00-10.17 0z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
